import { render, staticRenderFns } from "./sekretariat.vue?vue&type=template&id=b90fd98a"
import script from "./sekretariat.vue?vue&type=script&lang=js"
export * from "./sekretariat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports